import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' }
  },
  {
    name: 'Monitoreo',
    iconComponent: { name: 'cilChart' },
    children: [
      {
        name: 'Kuma',
        url: '/monitoring/kuma',
        iconComponent: { name: 'cilMediaRecord' }
      },
      {
        name: 'Kuma Oregon',
        url: '/monitoring/kuma-oregon',
        iconComponent: { name: 'cilMediaRecord' }
      }
    ]
  },
  {
    name: 'Dispositivos',
    url: '/devices',
    iconComponent: { name: 'cil-devices' }
  }
];
